export default {
  sm: `
  친환경 
  데이터센터의 
  기준,
  데이터센터 각
  `,
  md: `
  친환경 데이터센터의 기준,
  데이터센터 각
  `,
  lg: `
  친환경 
  데이터센터의 기준,
  데이터센터 각
  `,
  xxl: `
  친환경 데이터센터의 기준,
  데이터센터 각
  `
};
